module.exports = __webpack_public_path__ + "static/media/content.f856dae6.svg";